import { Root, Thumb } from '@radix-ui/react-switch';
import clsx from 'clsx';
import type { ComponentProps, FunctionComponent } from 'react';

export type SwitchProps = ComponentProps<typeof Root> & {
    readonly className?: string;
    readonly disabled?: boolean;
};

export const Switch: FunctionComponent<SwitchProps> = ({ className, disabled = false, ...props }) => {
    return (
        <Root
            className={clsx(
                'block relative h-[20px] w-[30px]',
                'bg-surface-interactive border-none rounded-full',
                'cursor-pointer transition-[background-color,opacity] duration-100 ease-in-out',
                'focus-visible:outline-2 focus-visible:outline-focus-ring-soft focus-visible:outline-offset-2',
                'data-[state=checked]:bg-accent',
                'disabled:bg-surface-subtle disabled:cursor-default disabled:opacity-50',
                className,
            )}
            disabled={disabled}
            {...props}
        >
            <Thumb
                className={clsx(
                    'block absolute top-[2px] left-[2px]',
                    'h-[16px] w-[16px] rounded-full bg-surface-raised',
                    'transition-transform duration-100 ease-in-out',
                    'data-[state=checked]:translate-x-[10px]',
                    'disabled:bg-surface-canvas',
                )}
            />
        </Root>
    );
};
